export default "__VITE_ASSET__BvTJkNTu__"